import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { UserProfileProvider } from './contexts/UserProfileContext';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import { useCategories } from './hooks/useCategories';
import { useTags } from './hooks/useTags';

function App() {
  const [searchValue, setSearchValue] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  // 카테고리 및 태그 데이터
  const { categories, loading: categoriesLoading } = useCategories();
  const { tags, loading: tagsLoading } = useTags();

  const handleSearch = (query: string) => {
    setSearchValue(query);
  };

  const handleSelectCategory = (categoryId: number | null) => {
    setSelectedCategory(categoryId);
  };

  const handleToggleTag = (tagName: string) => {
    setSelectedTags(prev => 
      prev.includes(tagName)
        ? prev.filter(tag => tag !== tagName)
        : [...prev, tagName]
    );
  };

  return (
    <UserProfileProvider>
      <AuthProvider>
        <Router>
        <Layout
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          onSearch={handleSearch}
          categories={categories}
          categoriesLoading={categoriesLoading}
          selectedCategory={selectedCategory}
          onSelectCategory={handleSelectCategory}
          tags={tags}
          tagsLoading={tagsLoading}
          selectedTags={selectedTags}
          onToggleTag={handleToggleTag}
        >
          <Routes>
            <Route 
              path="/" 
              element={
                <HomePage
                  searchValue={searchValue}
                  selectedCategory={selectedCategory}
                  selectedTags={selectedTags}
                />
              } 
            />
            <Route path="/favorites" element={<div>즐겨찾기 페이지</div>} />
            <Route path="/stats" element={<div>통계 페이지</div>} />
            <Route path="/settings" element={<div>설정 페이지</div>} />
          </Routes>
        </Layout>
        </Router>
      </AuthProvider>
    </UserProfileProvider>
  );
}

export default App;
